var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "shop-cart" },
    [
      _vm.orderComplete
        ? [
            _c("shop-headline", {
              attrs: { headline: _vm.$t("orderComplete.headline") },
            }),
          ]
        : [
            _c("shop-headline", {
              attrs: { headline: _vm.$t("cart"), icon: "cart" },
            }),
          ],
      _vm._v(" "),
      _vm.orderComplete
        ? [
            _c("p", {
              domProps: {
                innerHTML: _vm._s(_vm.$t("orderComplete.paragraph1")),
              },
            }),
            _vm._v(" "),
            _c("p", {
              domProps: {
                innerHTML: _vm._s(_vm.$t("orderComplete.paragraph2")),
              },
            }),
            _vm._v(" "),
            _c("p", [
              _c("b", {
                domProps: {
                  innerHTML: _vm._s(_vm.$t("orderComplete.paragraph3")),
                },
              }),
            ]),
          ]
        : _vm.isEmpty
        ? [
            _c("template", {
              domProps: { innerHTML: _vm._s(_vm.$t("login.headline")) },
              slot: "headline",
            }),
            _vm._v(" "),
            _c(
              "shop-info-box",
              [
                _c("template", { slot: "info-area" }, [
                  _c("p", {
                    domProps: { innerHTML: _vm._s(_vm.$t("isEmpty")) },
                  }),
                ]),
              ],
              2
            ),
            _vm._v(" "),
            _c("p", { domProps: { innerHTML: _vm._s(_vm.$t("emptyNotice")) } }),
            _vm._v(" "),
            !_vm.authenticated
              ? _c(
                  "shop-login",
                  {
                    attrs: { slot: "body", buttons: _vm.buttons },
                    slot: "body",
                  },
                  [
                    [
                      _c("h3", [_vm._v(_vm._s(_vm.$t("login.headline")))]),
                      _vm._v(" "),
                      _c("p", {
                        domProps: { innerHTML: _vm._s(_vm.$t("login.body")) },
                      }),
                    ],
                  ],
                  2
                )
              : _vm._e(),
          ]
        : [
            _vm.$t("infoBanner.paragraph1").length
              ? _c(
                  "shop-info-box",
                  [
                    _c("template", { slot: "info-area" }, [
                      _c("p", {
                        domProps: {
                          innerHTML: _vm._s(_vm.$t("infoBanner.paragraph1")),
                        },
                      }),
                      _vm._v(" "),
                      _c("p", {
                        domProps: {
                          innerHTML: _vm._s(_vm.$t("infoBanner.paragraph2")),
                        },
                      }),
                      _vm._v(" "),
                      _c("p", {
                        domProps: {
                          innerHTML: _vm._s(_vm.$t("infoBanner.paragraph3")),
                        },
                      }),
                      _vm._v(" "),
                      _c("p", {
                        domProps: {
                          innerHTML: _vm._s(_vm.$t("infoBanner.paragraph4")),
                        },
                      }),
                      _vm._v(" "),
                      _c("p", {
                        domProps: {
                          innerHTML: _vm._s(_vm.$t("infoBanner.paragraph5")),
                        },
                      }),
                    ]),
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.authenticated
              ? _c(
                  "shop-section",
                  [
                    _c("template", {
                      domProps: { innerHTML: _vm._s(_vm.$t("login.headline")) },
                      slot: "headline",
                    }),
                    _vm._v(" "),
                    _c(
                      "shop-login",
                      {
                        attrs: { slot: "body", buttons: _vm.buttons },
                        slot: "body",
                      },
                      [
                        [
                          _c("h3", [_vm._v(_vm._s(_vm.$t("login.headline")))]),
                          _vm._v(" "),
                          _c("p", {
                            domProps: {
                              innerHTML: _vm._s(_vm.$t("login.body")),
                            },
                          }),
                        ],
                      ],
                      2
                    ),
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.authenticated
              ? _c(
                  "shop-section",
                  [
                    _c("template", { slot: "preamble" }, [
                      _c("span", {
                        domProps: {
                          innerHTML: _vm._s(_vm.replacedMaxItemsNotice),
                        },
                      }),
                    ]),
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.cartData.items, function (section, sectionIndex) {
              return [
                section.items.length
                  ? _c(
                      "shop-section",
                      [
                        _c("template", { slot: "headline" }, [
                          _vm._v(
                            "\n                    " +
                              _vm._s(section.sectionTitle) +
                              "\n                "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "template",
                          { slot: "body" },
                          [
                            _vm.showFanboxOption &&
                            section.category === "faecher"
                              ? _c("shop-fanbox", {
                                  attrs: {
                                    items: section.items,
                                    "max-order-items": section.maxOrderItems,
                                  },
                                })
                              : _c(
                                  "div",
                                  { staticClass: "row" },
                                  [
                                    _vm._l(
                                      section.items,
                                      function (item, itemIndex) {
                                        return [
                                          _c(
                                            "shop-tile",
                                            {
                                              key: item.order_pid,
                                              staticClass: "col-12 col-md-6",
                                              attrs: { tile: item },
                                            },
                                            [
                                              _c(
                                                "template",
                                                { slot: "button-add2wishlist" },
                                                [
                                                  _c("span", {
                                                    staticClass:
                                                      "wish-list link link--primary link--icon icon--small icon--before icon--wishlist-empty",
                                                    attrs: {
                                                      "data-pid":
                                                        item.order_pid,
                                                      "data-title": item.title,
                                                      "data-titlesuffix":
                                                        item.titlesuffix,
                                                      "data-subtitle":
                                                        item.subtitle,
                                                      "data-subsubtitle":
                                                        item.subsubtitle,
                                                    },
                                                  }),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "template",
                                                { slot: "ordercount" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "show",
                                                          rawName: "v-show",
                                                          value:
                                                            _vm.authenticated,
                                                          expression:
                                                            "authenticated",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "col-12 ordercount-input",
                                                      class: [
                                                        _vm.cartData.items[
                                                          sectionIndex
                                                        ].items[itemIndex]
                                                          .orderQuantityError
                                                          ? "has-error"
                                                          : "no-error",
                                                      ],
                                                    },
                                                    [
                                                      _c(
                                                        "global-item-quantity",
                                                        {
                                                          attrs: {
                                                            min: 1,
                                                            value:
                                                              _vm.$store.getters.cartGetCartOrderQuantityForPimId(
                                                                item.pim_id
                                                              ),
                                                            max: _vm.maxOrderQuantityForItem(
                                                              item,
                                                              parseInt(
                                                                section.maxOrderItems
                                                              )
                                                            ),
                                                            "error-messages": {
                                                              errorToSmall:
                                                                _vm.$t(
                                                                  "errorItemQuantityMin"
                                                                ),
                                                              errorToLarge:
                                                                _vm.$t(
                                                                  "errorItemQuantityMax"
                                                                ),
                                                              errorNotANumber:
                                                                _vm.$t(
                                                                  "errorItemQuantityEmpty"
                                                                ),
                                                            },
                                                          },
                                                          on: {
                                                            updateErrorItemQuantity:
                                                              function (
                                                                $event
                                                              ) {
                                                                $event
                                                                  ? _vm.$store.dispatch(
                                                                      "addCartErrorItem",
                                                                      item.pim_id
                                                                    )
                                                                  : _vm.$store.dispatch(
                                                                      "removeCartErrorItem",
                                                                      item.pim_id
                                                                    )
                                                              },
                                                            updateCartData:
                                                              function (
                                                                $event
                                                              ) {
                                                                return _vm.$store.dispatch(
                                                                  "changeCartOrderQuantity",
                                                                  {
                                                                    pim_id:
                                                                      item.pim_id,
                                                                    quantity:
                                                                      $event,
                                                                  }
                                                                )
                                                              },
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              attrs: {
                                                                slot: "amount",
                                                              },
                                                              slot: "amount",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "orderquantity"
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("global-button", {
                                                        attrs: {
                                                          icon: "trash",
                                                          theme: "secondary",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.remove(
                                                              item.pim_id
                                                            )
                                                          },
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "template",
                                                { slot: "remove-button" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "show",
                                                          rawName: "v-show",
                                                          value:
                                                            _vm.authenticated ===
                                                            false,
                                                          expression:
                                                            "authenticated === false",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "button-wrapper spacer--top",
                                                    },
                                                    [
                                                      _c("global-button", {
                                                        attrs: {
                                                          icon: "trash",
                                                          theme: "secondary",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.remove(
                                                              item.pim_id
                                                            )
                                                          },
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              ),
                                            ],
                                            2
                                          ),
                                        ]
                                      }
                                    ),
                                  ],
                                  2
                                ),
                          ],
                          1
                        ),
                      ],
                      2
                    )
                  : _vm._e(),
              ]
            }),
            _vm._v(" "),
            !_vm.authenticated && !_vm.isEmpty
              ? _c(
                  "shop-section",
                  [
                    _c(
                      "shop-login",
                      {
                        attrs: { slot: "body", buttons: _vm.buttons },
                        slot: "body",
                      },
                      [
                        [
                          _c("h3", [_vm._v(_vm._s(_vm.$t("login.headline")))]),
                          _vm._v(" "),
                          _c("p", {
                            domProps: {
                              innerHTML: _vm._s(_vm.$t("login.body")),
                            },
                          }),
                        ],
                      ],
                      2
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.authenticated
              ? _c(
                  "shop-section",
                  { staticClass: "shop-section--border" },
                  [
                    _c("template", { slot: "body" }, [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-12 col-md-6" }, [
                          _vm.alternateAddress
                            ? _c("p", [
                                _c("b", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.$t("checkout.invoiceAddress")
                                    ),
                                  },
                                }),
                              ])
                            : _c("p", [
                                _c("b", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.$t("checkout.deliveryInvoiceAddress")
                                    ),
                                  },
                                }),
                              ]),
                          _vm._v(" "),
                          _c("address", { staticClass: "address" }, [
                            _vm.userAddress.company
                              ? _c("span", [
                                  _vm._v(_vm._s(_vm.userAddress.company)),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.userAddress.firstName) +
                                  " " +
                                  _vm._s(_vm.userAddress.lastName)
                              ),
                            ]),
                            _vm._v(" "),
                            _vm.userAddress.street
                              ? _c("span", [
                                  _vm._v(_vm._s(_vm.userAddress.street)),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("span", { staticClass: "spacer" }, [
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.userAddress.postCode) +
                                    " " +
                                    _vm._s(_vm.userAddress.city)
                                ),
                              ]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.countryByKey[_vm.userAddress.country]
                                  )
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _vm.userAddress.phone.length
                              ? _c("span", { staticClass: "spacer" }, [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.$t("checkout.labels.tel")) +
                                        " " +
                                        _vm._s(_vm.userAddress.phone)
                                    ),
                                  ]),
                                ])
                              : _vm._e(),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-12 col-md-6" },
                          [
                            _c("shop-alternate-address", {
                              ref: "alternateAddress",
                              attrs: {
                                show: _vm.showAlternateAddress,
                                "user-address": _vm.userAddress,
                              },
                              on: {
                                alternateAddress: function ($event) {
                                  return _vm.setAlternateAddress($event.detail)
                                },
                                close: function ($event) {
                                  _vm.showAlternateAddress = false
                                },
                              },
                            }),
                            _vm._v(" "),
                            [
                              _c(
                                "shop-info-box",
                                [
                                  _c("template", { slot: "info-area" }, [
                                    _c("p", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$t(
                                            "checkout.alternateAddressNotice"
                                          )
                                        ),
                                      },
                                    }),
                                  ]),
                                  _vm._v(" "),
                                  _c("template", { slot: "cta-area" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "button-wrapper bottom left",
                                      },
                                      [
                                        _c("button", {
                                          staticClass: "button button--primary",
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.$t(
                                                "checkout.alternateAddress"
                                              )
                                            ),
                                          },
                                          on: {
                                            click: function ($event) {
                                              _vm.showAlternateAddress = true
                                            },
                                          },
                                        }),
                                      ]
                                    ),
                                  ]),
                                ],
                                2
                              ),
                            ],
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _vm.alternateAddress &&
                        _vm.address.mainAddress === false
                          ? _c("div", { staticClass: "col-12 col-md-6" }, [
                              _c("p", [
                                _c("b", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.$t("checkout.deliveryAddress")
                                    ),
                                  },
                                }),
                              ]),
                              _vm._v(" "),
                              _c("address", { staticClass: "address" }, [
                                _vm.address.company
                                  ? _c("span", [
                                      _vm._v(_vm._s(_vm.address.company)),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.address.firstName) +
                                      " " +
                                      _vm._s(_vm.address.lastName)
                                  ),
                                ]),
                                _vm._v(" "),
                                _vm.address.street
                                  ? _c("span", [
                                      _vm._v(_vm._s(_vm.address.street)),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("span", { staticClass: "spacer" }, [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.address.postCode) +
                                        " " +
                                        _vm._s(_vm.address.city)
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.countryByKey[_vm.address.country]
                                      )
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _vm.userAddress.phone.length
                                  ? _c("span", { staticClass: "spacer" }, [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("checkout.labels.tel")
                                          ) +
                                            " " +
                                            _vm._s(_vm.address.phone)
                                        ),
                                      ]),
                                    ])
                                  : _vm._e(),
                              ]),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-12" },
                          [
                            _c(
                              "shop-info-box",
                              [
                                _c("template", { slot: "info-area" }, [
                                  _c("h3", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.$t(
                                          "checkout.objectNameInfoHeadline"
                                        )
                                      ),
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("p", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.$t("checkout.objectNameInfoBody")
                                      ),
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "form-group" }, [
                                    _c(
                                      "label",
                                      {
                                        staticClass: "form__label",
                                        attrs: { for: "objectName" },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "checkout.objectNameInputLabel"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.objectName,
                                          expression: "objectName",
                                        },
                                      ],
                                      staticClass:
                                        "form__input form__input--text form--light col-md-6",
                                      attrs: {
                                        type: "text",
                                        maxlength: "22",
                                        id: "objectName",
                                      },
                                      domProps: { value: _vm.objectName },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.objectName = $event.target.value
                                        },
                                      },
                                    }),
                                  ]),
                                ]),
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                      ]),
                    ]),
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _c("shop-section", [
              _c(
                "div",
                { staticClass: "form-group has-error" },
                [
                  _vm._l(Object.values(_vm.backendErrors), function (value) {
                    return [
                      value !== ""
                        ? _c("p", { staticClass: "form__error" }, [
                            _vm._v(_vm._s(value)),
                          ])
                        : _vm._e(),
                    ]
                  }),
                ],
                2
              ),
            ]),
            _vm._v(" "),
            !_vm.isEmpty && _vm.authenticated
              ? _c("global-input-checkbox", {
                  attrs: {
                    label: _vm.$t("checkout.customs.label"),
                    "show-required-star": "true",
                    error:
                      _vm.customsChecked === false
                        ? _vm.$t("checkout.customs.error")
                        : null,
                  },
                  on: {
                    input: function ($event) {
                      _vm.customsChecked = $event
                    },
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            !_vm.isEmpty && _vm.authenticated
              ? _c(
                  "shop-checkout-button",
                  {
                    staticClass: "shop-checkout__button--bottom",
                    attrs: {
                      showErrorMessage: false,
                      orderItemCount: _vm.orderItemCount,
                      newsletterlabel: _vm.$t("checkout.newsletterLabel"),
                      newsletteruri: _vm.$t("checkout.newsletterUri"),
                      shopDisabled: _vm.shopDisabled,
                    },
                    on: { order: _vm.requestOrder },
                  },
                  [
                    _c("template", { slot: "button-label" }, [
                      _c("span", {
                        domProps: {
                          innerHTML: _vm._s(_vm.$t("checkout.order")),
                        },
                      }),
                    ]),
                  ],
                  2
                )
              : _vm._e(),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }